import { render, staticRenderFns } from "./RepartitionDashboard.vue?vue&type=template&id=38eebfb4&scoped=true&"
import script from "./RepartitionDashboard.vue?vue&type=script&lang=js&"
export * from "./RepartitionDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38eebfb4",
  null
  
)

export default component.exports